<template>
    <div
        class="modal fade"
        :id="`${resource}-assign`"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalComponent"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-body p-3" style="min-height: 70vh">
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="closeModal"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>

                    <div class="row">
                        <div class="col-12 col-lg-6" v-if="selectedAssignee">
                            <div class="border-bottom">
                                <div class="d-flex p-2 list-item bg-white cursor-pointer">
                                    <div>
                                        <img
                                            class="resource-image"
                                            :src="selectedAssignee.profile_photo_url"
                                        />
                                    </div>
                                    <div class="ml-3 d-block">
                                        <h4 class="p-0 m-0 font-italic">
                                            {{ selectedAssignee.name }}
                                        </h4>
                                    </div>
                                </div>
                                <p class="font-weight-bold mt-3">
                                    <span class="text-capitalize">{{ resource.slice(0, -1) }}</span>
                                    Connections to {{ selectedAssignee.first_name }}
                                </p>
                                <p class="small" v-if="resource === 'therapists'">
                                    Everyone in this list will have access to
                                    {{ selectedAssignee.first_name }}'s data. This includes viewing
                                    goals, viewing past data and tracking new data.
                                </p>
                                <p class="small" v-if="resource === 'patients'">
                                    {{ selectedAssignee.first_name }} will have access to the data
                                    of everyone in this list. This includes viewing goals, viewing
                                    past data and tracking new data.
                                </p>
                            </div>
                            <div
                                v-if="selectedAssignee && selectedAssignee[resource]"
                                :class="{ 'resources-list': selectedAssignee[resource].length }"
                            >
                                <div
                                    class="d-flex bg-white list-item p-2"
                                    v-for="(u, i) in selectedAssignee[resource].filter(
                                        s => s.id === user.id && resource === 'therapists'
                                    )"
                                    :key="`ct${u.id}`"
                                >
                                    <div>
                                        <img class="resource-image" :src="u.profile_photo_url" />
                                    </div>
                                    <div class="ml-3 d-block details">
                                        <h4 class="p-0 m-0">
                                            <em>{{ `${u.name}` }}</em>
                                        </h4>
                                        <p class="p-0 m-0 text-uppercase">{{ u.title || "" }}</p>
                                    </div>
                                    <div
                                        class="d-flex flex-column justify-content-center align-items-center text-primary ml-auto"
                                    >
                                        <i class="fa fa-fw"></i>
                                        <small class="text-uppercase font-weight-bold">Owner</small>
                                    </div>
                                </div>
                                <div
                                    class="d-flex bg-white list-item p-2"
                                    v-for="(u, i) in selectedAssignee[resource].filter(
                                        s => s.id !== user.id || resource !== 'therapists'
                                    )"
                                    :key="`ct${u.id}`"
                                >
                                    <div>
                                        <img class="resource-image" :src="u.profile_photo_url" />
                                    </div>
                                    <div class="ml-3 d-block details">
                                        <h4 class="p-0 m-0">
                                            <em>{{ `${u.name}` }}</em>
                                        </h4>
                                        <p class="p-0 m-0 text-uppercase">{{ u.title || "" }}</p>
                                    </div>
                                    <div
                                        class="cursor-pointer d-flex flex-column justify-content-center align-items-center text-primary ml-auto"
                                        @click.stop="detachResource(u)"
                                    >
                                        <i class="fa fa-chevron-circle-right"></i>
                                        <small class="text-uppercase font-weight-bold"
                                            >Remove</small
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-6 border-left-lg mt-3 mt-lg-0">
                            <div class="border-bottom">
                                <p class="font-weight-bold text-capitalize mt-3">
                                    {{ organization.name }} - All {{ resource }}
                                </p>
                                <p class="small" v-if="resource === 'therapists'">
                                    Everyone in this list will NOT have access to
                                    {{
                                        selectedAssignee ? selectedAssignee.first_name : "Assignee"
                                    }}'s data.
                                </p>
                                <p class="small" v-if="resource === 'patients'">
                                    {{
                                        selectedAssignee ? selectedAssignee.first_name : "Assignee"
                                    }}
                                    will NOT have access to the data of anyone in this list.
                                </p>
                            </div>

                            <template v-if="loading">
                                <p class="my-3 font-italic">
                                    <i class="fa fa-spin fa-circle-o-notch mr-2"></i>Fetching
                                    list...
                                </p>
                            </template>
                            <template v-else="">
                                <input
                                    id="resource-filter"
                                    type="text"
                                    class="my-2 form-control-sm form-control"
                                    v-model="filter"
                                    placeholder="Search by first or last name"
                                />
                                <section class="resources-list">
                                    <div
                                        class="d-flex bg-white list-item p-2"
                                        v-for="(u, i) in detachedResources"
                                        :key="`ct${i}`"
                                    >
                                        <div
                                            class="cursor-pointer d-flex flex-column justify-content-center align-items-center text-primary mr-3"
                                            @click.stop="attachResource(u)"
                                        >
                                            <i class="fa fa-chevron-circle-left"></i>
                                            <small class="text-uppercase font-weight-bold"
                                                >Add</small
                                            >
                                        </div>
                                        <div>
                                            <img
                                                class="resource-image"
                                                :src="u.profile_photo_url"
                                            />
                                        </div>
                                        <div class="ml-3 d-block details">
                                            <h4 class="p-0 m-0">
                                                <em>{{ `${u.name}` }}</em>
                                            </h4>
                                            <p class="p-0 m-0 text-uppercase">{{ u.title }}</p>
                                        </div>
                                    </div>
                                    <div v-if="!detachedResources.length" class="font-italic p-2">
                                        <h5>No results</h5>
                                    </div>
                                </section>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { permissions } from "../../plugins/permissions";

export default {
    name: "AssignResource",
    props: ["user", "organization", "selectedAssignee", "visible", "resource", "handleClose"],
    mixins: [permissions],
    data() {
        return {
            loading: true,
            filter: "",
            resourceList: [],
        };
    },
    mounted() {
        this.loading = true;
        // sets up a listener that triggers the "@close" event when the user closes the modal
        const self = this;
        $(`#${this.resource}-assign`).on("hidden.bs.modal", function() {
            self.$emit("handle-close");
        });
    },

    watch: {
        visible: {
            immediate: true,
            handler: function() {
                $(`#${this.resource}-assign`).modal(this.visible ? "show" : "hide");
                if (this.visible && this.resource) {
                    this.fetchResourceList();
                }
            },
        },
    },
    computed: {
        detachedResources() {
            if (
                this.resourceList &&
                this.resourceList.length &&
                this.selectedAssignee &&
                _.get(this.selectedAssignee, this.resource, []).length
            ) {
                return this.resourceList.filter(
                    u =>
                        !this.selectedAssignee[this.resource].map(t => t.id).includes(u.id) &&
                        u.name.toLowerCase().includes(this.filter.toLowerCase().trim())
                );
            }
            return this.resourceList;
        },
    },
    methods: {
        closeModal() {
            $(`#${this.resource}-assign`).modal("hide");
            this.$bus.$emit("update-resource");
        },
        fetchResourceList() {
            this.loading = true;
            if (this.resource === "patients") {
                this.fetchPatients();
            }
            if (this.resource === "therapists") {
                this.fetchTherapists();
            }
        },
        fetchTherapists() {
            const apiUrl = "/api/organizations/" + this.organization.id + "/users";
            axios
                .get(apiUrl)
                .then(r => {
                    this.loading = false;
                    this.resourceList = r.data.data;
                })
                .catch(error => {
                    console.error(error);
                });
        },
        fetchPatients() {
            let params = { params: { organization_id: this.organization.id } };
            const apiUrl = "/api/patients";
            axios.get(apiUrl, params).then(r => {
                this.loading = false;
                this.resourceList = r.data.data;
            });
        },
        attachResource(resource) {
            if (!this.canEditStaff) return;
            const user_id = this.resource === "therapists" ? resource.id : this.selectedAssignee.id;
            const patient_id =
                this.resource === "patients" ? resource.id : this.selectedAssignee.id;
            let payload = {
                patient_ids: [patient_id],
            };
            axios
                .post(`/api/users/${user_id}/patient`, payload)
                .then(response => {
                    this.$emit("update-resource", resource);
                })
                .catch(error => {
                    console.error(error);
                });
        },
        detachResource(resource) {
            if (!this.canEditStaff) return;
            const user_id = this.resource === "therapists" ? resource.id : this.selectedAssignee.id;
            const patient_id =
                this.resource === "patients" ? resource.id : this.selectedAssignee.id;
            axios
                .delete(`/api/users/${user_id}/patient/${patient_id}`)
                .then(response => {
                    this.$emit("update-resource", resource);
                })
                .catch(error => {
                    console.error(error);
                });
        },
    },
};
</script>

<style scoped lang="scss">
#resource-filter::placeholder {
    font-style: italic;
    color: lightgray;
}
.modal-header {
    padding-bottom: 0.5rem;
}

.resources-list {
    overflow-y: scroll;
    max-height: 50vh;
    border: solid 1px #bfbfbf;
}

.resource-image {
    width: 64px;
    height: 64px;
}

.details {
    > p {
        font-size: 100%;
    }
}

.list-item:not(:first-child) {
    border-top: none;
}

.list-item {
    border-bottom: solid 1px #bfbfbf;
}

.form-check-input {
    margin-top: auto;
    margin-bottom: auto;
}

.border-left-lg {
    @media screen and (min-width: 992px) {
        border-left: 1px solid #dee2e6 !important;
    }
}
</style>
